export default [
  {
    id: 'letterprofile',
    title: 'プロフィール',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'company',
    title: '応募会社',
    previewJumpId: 'company'
  },
  {
    id: 'intro',
    title: 'あいさつ',
    previewJumpId: 'intro'
  },
  {
    id: 'entry-detail',
    title: '応募経緯',
    previewJumpId: 'entry'
  },
  {
    id: 'resume-list',
    title: '同封書類',
    previewJumpId: 'resume'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'output',
    title: 'ダウンロード',
    previewJumpId: 'preview-page-01'
  }
]
